import React from "react";
import { formatDate } from "../../../../../services/formateDate";
import { getStatusValue } from "../../../../../services/cardStatus";

const BookingCard = ({ cardDetails,otherProfile }) => {
  return (
    <div
      id="w-node-db34551f-91ae-6027-0afb-f35ba77e5590-27b28b52"
      className="table-list-card"
    >
      <div className="property-image custom-bg _2">
        <div className="table-card-div">
          <div className="property-image-inner">
            <div className="p-image-inner-info-top">
              <div className="card-image-left-meta">
                <p className="category">{cardDetails?.category?.name}</p>
              </div>
              {cardDetails?.bookmarks > 0 && (
                <div className="card-image-left-meta">
                  <div className="text-block">
                    {cardDetails?.bookmarks > 0 && cardDetails?.bookmarks}
                  </div>
                </div>
              )}
            </div>
          </div>
          <a
            id="w-node-db34551f-91ae-6027-0afb-f35ba77e559d-27b28b52"
            className="table-card-image w-inline-block"
          >
            <img
              loading="lazy"
              src={cardDetails?.media}
              alt=""
              className="table-image-oncard account-page-my-table placeholderimg"
            />
          </a>
        </div>
      </div>
      <a
        id="w-node-db34551f-91ae-6027-0afb-f35ba77e559f-27b28b52"
        href="#"
        className="card-details w-inline-block"
      >
        <div className="card-meta-datat">
          <div
            id="w-node-db34551f-91ae-6027-0afb-f35ba77e55a1-27b28b52"
            className="location-div"
          >
            <div className="code-embed-4 location-icon-oncard w-embed">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width={20}
                height={20}
                viewBox="0,0,256,256"
              >
                <g
                  fill="#e2b760"
                  fillRule="nonzero"
                  stroke="none"
                  strokeWidth={1}
                  strokeLinecap="butt"
                  strokeLinejoin="miter"
                  strokeMiterlimit={10}
                  strokeDasharray=""
                  strokeDashoffset={0}
                  fontFamily="none"
                  fontWeight="none"
                  fontSize="none"
                  textAnchor="none"
                  style={{ mixBlendMode: "normal" }}
                >
                  <g transform="scale(5.33333,5.33333)">
                    <path d="M24,4c-9.374,0 -17,7.626 -17,17c0,4.036 1.449,7.953 4.093,11.048c0.302,0.343 7.427,8.439 9.807,10.708c0.869,0.829 1.984,1.244 3.1,1.244c1.116,0 2.231,-0.415 3.101,-1.244c2.767,-2.639 9.524,-10.385 9.82,-10.725c2.63,-3.078 4.079,-6.995 4.079,-11.031c0,-9.374 -7.626,-17 -17,-17zM24,26c-2.761,0 -5,-2.239 -5,-5c0,-2.761 2.239,-5 5,-5c2.761,0 5,2.239 5,5c0,2.761 -2.239,5 -5,5z" />
                  </g>
                </g>
              </svg>
            </div>
            <div className="card-location feature-label">
              {cardDetails?.city}
            </div>
          </div>
          <div className="date-on-card">
            <div className="code-embed-4 date-icon-on-card w-embed">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width={20}
                height={20}
                viewBox="0,0,256,256"
              >
                <g
                  fill="#e2b760"
                  fillRule="nonzero"
                  stroke="none"
                  strokeWidth={1}
                  strokeLinecap="butt"
                  strokeLinejoin="miter"
                  strokeMiterlimit={10}
                  strokeDasharray=""
                  strokeDashoffset={0}
                  fontFamily="none"
                  fontWeight="none"
                  fontSize="none"
                  textAnchor="none"
                  style={{ mixBlendMode: "normal" }}
                >
                  <g transform="scale(5.33333,5.33333)">
                    <path d="M42,14v-1.5c0,-3.584 -2.916,-6.5 -6.5,-6.5h-23c-3.584,0 -6.5,2.916 -6.5,6.5v1.5zM6,17v18.5c0,3.584 2.916,6.5 6.5,6.5h23c3.584,0 6.5,-2.916 6.5,-6.5v-18.5zM15.5,36c-1.381,0 -2.5,-1.119 -2.5,-2.5c0,-1.381 1.119,-2.5 2.5,-2.5c1.381,0 2.5,1.119 2.5,2.5c0,1.381 -1.119,2.5 -2.5,2.5zM15.5,27c-1.381,0 -2.5,-1.119 -2.5,-2.5c0,-1.381 1.119,-2.5 2.5,-2.5c1.381,0 2.5,1.119 2.5,2.5c0,1.381 -1.119,2.5 -2.5,2.5zM24,36c-1.381,0 -2.5,-1.119 -2.5,-2.5c0,-1.381 1.119,-2.5 2.5,-2.5c1.381,0 2.5,1.119 2.5,2.5c0,1.381 -1.119,2.5 -2.5,2.5zM24,27c-1.381,0 -2.5,-1.119 -2.5,-2.5c0,-1.381 1.119,-2.5 2.5,-2.5c1.381,0 2.5,1.119 2.5,2.5c0,1.381 -1.119,2.5 -2.5,2.5zM32.5,27c-1.381,0 -2.5,-1.119 -2.5,-2.5c0,-1.381 1.119,-2.5 2.5,-2.5c1.381,0 2.5,1.119 2.5,2.5c0,1.381 -1.119,2.5 -2.5,2.5z" />
                  </g>
                </g>
              </svg>
            </div>
      
            <div className="card-location feature-label">
              {formatDate(cardDetails?.event_date)}
            </div>
          </div>
        </div>
        {
              !otherProfile && 
              <div className="rounded-full w-28 mt-2 border border-slate-300 py-0.5 px-2.5 text-center text-sm transition-all shadow-sm text-slate-600">
              {getStatusValue(cardDetails?.status)}
            </div>
            }
      
        <div className="card-title">{cardDetails?.title}</div>
      </a>
    </div>
  );
};

export default BookingCard;
